import * as React from "react";
import { forwardRef } from "react";
const SvgStreamlineUltimateLoading = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 10.5, cy: 10, r: 1.5, fill: "white" }), /* @__PURE__ */ React.createElement("circle", { cx: 5, cy: 10, r: 2, fill: "white" }), /* @__PURE__ */ React.createElement("circle", { cx: 15, cy: 10, r: 1, fill: "white" }));
const ForwardRef = forwardRef(SvgStreamlineUltimateLoading);
export { ForwardRef as ReactComponent };
